import { getService, getAxiosHeaders } from "../../library/RestAPI";
import { fetchAcceptAlertsAPI } from "../constants/constants";

export async function getAcceptedRisks(
  alertId,
  pageSize,
  currentPage
) {
  const options = {
    method: "GET",
    url: `${fetchAcceptAlertsAPI(
      alertId
    )}?size=${pageSize}&page=${currentPage}`,
    headers: getAxiosHeaders(true),
    data: {},
  };

  const response = await getService(options);

  if (response) {
    return response.data;
  }

  return null;
}